import { FspDirectionRefEntity } from "domain/entity/FspDirectionRef/FspDirectionRefEntity";
import { axiosGetData } from "../axios/AxiosBasicImpl";
import referenceAxiosInstance from "../axios/referenceAxiosInstance";
import { FspDirectionRefRepository } from "./FspDirectionRefRepo";

export const FspDirectionRefRepoImpl = (): FspDirectionRefRepository => {
    const url = '/v1/fspDirectionRefMapping'
    const getAllFspDirectionRefComboBox = async (): Promise<FspDirectionRefEntity[]> => {
        return axiosGetData(referenceAxiosInstance, url, []).then(res => {
            return res.data;
        }).catch(err => {
            return [];
        })
    }

    return {
        getAllFspDirectionRefComboBox: getAllFspDirectionRefComboBox
    }
}